import { render, staticRenderFns } from "./AccettazioneSsnAnagraficaComponent.vue?vue&type=template&id=5b92b45e&scoped=true"
import script from "./AccettazioneSsnAnagraficaComponent.vue?vue&type=script&lang=js"
export * from "./AccettazioneSsnAnagraficaComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b92b45e",
  null
  
)

export default component.exports